import { IColor } from "@/domain/entities/serviceInfo/serviceInfo.types";

export default function useSetColor(color: IColor): void {
  for (const [key, value] of Object.entries(color)) {
    if (!value) continue;
    const propertyKey = `--${key.replace(/([A-Z])/g, "-$1").toLowerCase()}`;
    document.documentElement.style.setProperty(propertyKey, value);
  }
}
